module.exports = "<app-visit-report [isTroubleShhotingLifeRecord]=\"isTroubleShhotingLifeRecord\" [title]=\"title\"></app-visit-report>"